// extracted by mini-css-extract-plugin
export default {"root__toggle":"style-module__root__toggle___wGh4U","root__time":"style-module__root__time___uiNIW"};
    if(module.hot) {
      // 1729151133280
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  